export const generateErrorNotice = (payload, defaultError) => ({
  type: 'error',
  message:
    payload?.message ||
    defaultError ||
    "We're experiencing issues related to your session, please refresh this window.",
  errorObject: payload,
});
